/* eslint-disable @typescript-eslint/naming-convention */
import { getLocalizedText, getSupportedLanguages, LanguageKey } from '@softgames/localization';
import { v1 as uuidv1 } from 'uuid';
import { getBase64Asset } from '../../../utils/image-utils';
import type { LifeRequestPayload } from '../../entryPoints/types';
import type { Platform } from '../Platform';

/**
 * Allow the player to choose a context and send a life request.
 */
export async function sendLifeRequest(platform: Platform): Promise<boolean> {
  const { social } = platform;

  if (!social) return false;

  const contextChosen = await social.chooseSocialContext();
  if (!contextChosen) return false;

  const player = platform.getCurrentPlayer();
  const image = await getBase64Asset('Life_Request');
  const localizations = getUpdateLocalizations(player.name);

  const data: LifeRequestPayload = {
    payloadType: 'lifeRequest',
    uid: uuidv1(),
    timestamp: Date.now(),
    senderId: player.id,
    lives: 1,
  };

  return social.sendMessage({
    cta: getLocalizedText('Life Request'),
    template: 'send-lives',
    text: {
      default: localizations[LanguageKey.ENGLISH_US],
      localizations: {
        ...localizations,
      },
    },
    data,
    image,
  });
}

function getUpdateLocalizations(playerName: string): Record<LanguageKey, string> {
  const localizations: Partial<Record<LanguageKey, string>> = {};
  getSupportedLanguages().forEach((key) => {
    localizations[key] = getLocalizedText('<player> has requested a life!', key).replace('<player>', playerName);
  });
  return localizations as Record<LanguageKey, string>;
}
